import type { WorkScheduleResponse } from "./WorkScheduleResponse";
import type { WorkScheduleRequest } from "./WorkScheduleRequest";

export class WorkScheduleListItem {
  scheduleId: number;
  employeeId: number;
  employeeName: string;
  dayOfWeek: number;
  dayOfWeekName: string;
  startTime: string;
  endTime: string;
  recurringPatternLookupId: number | null;
  recurringPatternName: string | null;
  effectiveFrom: string;
  effectiveTo: string | null;
  createdDate: string;
  createdBy: string;
  modifiedDate: string;
  modifiedBy: string;

  constructor(response: WorkScheduleResponse) {
    this.scheduleId = response.scheduleId;
    this.employeeId = response.employeeId;
    this.employeeName = response.employeeName;
    this.dayOfWeek = response.dayOfWeek;
    this.dayOfWeekName = response.dayOfWeekName;
    this.startTime = response.startTime;
    this.endTime = response.endTime;
    this.recurringPatternLookupId = response.recurringPatternLookupId;
    this.recurringPatternName = response.recurringPatternName;
    this.effectiveFrom = response.effectiveFrom;
    this.effectiveTo = response.effectiveTo;
    this.createdDate = response.createdDate;
    this.createdBy = response.createdBy;
    this.modifiedDate = response.modifiedDate;
    this.modifiedBy = response.modifiedBy;
  }

  toRequest(): WorkScheduleRequest {
    return {
      employeeId: this.employeeId,
      daysOfWeek: [this.dayOfWeek], // Single day for edit mode
      startTime: this.startTime,
      endTime: this.endTime,
      recurringPatternLookupId: this.recurringPatternLookupId,
      effectiveFrom: this.effectiveFrom,
      effectiveTo: this.effectiveTo
    };
  }
}
